import type { ScrollHelper } from '@op/react-web'
import { createContext } from 'react'

export type AppScrollCtx = {
	readonly add: (id: string, $scrollEl?: HTMLElement) => ScrollHelper
	readonly remove: (id: string) => void
}

export const AppScrollContext = createContext<AppScrollCtx>(null as any)
